<template>
   <div>
        <div class="message-box d-flex justify-content-between align-items-end">
            <div class="message-left">
                <div class="message-block">
                    <p>Cảm ơn bạn nhỏ đã hoàn thành xuất sắc bài thi.</p>
                    <p>Thật vui vì được gặp bạn nhỏ trong thời gian tới!</p>
                </div>
                <img src="../../assets/character-1.png" alt="">
            </div>
            <div class="message-right">
                <div class="message-block">
                    <p>Bạn nhỏ có thể gặp Peri tại đây nhé.</p>
                    <div class="socical">
                        <div class="social-item">
                            <a href="https://www.facebook.com/vnspeakup" target="_blank">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                            </a>
                            <a href="https://speakup.vn/news/" target="_blank">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                            </a>
                            <a href="to:support@speakup.vn">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                            </a>
                            <a href="tel:0931188009">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                            </a>
                        </div>
                    </div>
                </div>
                <img src="../../assets/character-2.png" alt="">
            </div>
        </div>
   </div>
</template>

<script>

import {
    // BRow,
    // BCol
} from 'bootstrap-vue'

export default {
    data() {
        return {
        }
    },
    components: {
        // BRow,
        // BCol
    },
    computed: {
        examId () {
            return this.$store.state.examId
        },
    },
    mounted () {
    },
    created() {
    },
    methods: {
        
    }
}
</script>

<style scoped>

.message-left img {
    margin-top: 90px;
}

.message-left img, .message-right img {
    width: 80%;
    
}

.message-block {
    position: absolute;
}

.message-left {
    margin-top: 200px;
}

.message-left, .message-right {
    position: relative;
    text-align: center;
}


.message-box .message-block p {
    font-family: 'FS Ariston Comic Base';
    font-size: 2rem;
    line-height: 2.5rem;
    margin-bottom: 0px;
    color: #004fc6;
}

.message-box .message-block {
    position: absolute;
    background-color: #fff;
    padding: 30px;
    border: 6px solid #0788e0;
    border-radius: 20px;
}

.message-left .message-block {
    left: calc(100% - 50px);
    width: 400px;
    top: -67px;
}

.message-left .message-block p:first-child {
    color: #fc7b32;
}

.message-right .message-block {
    right: calc(100% - 76px);
    width: 300px;
    top: -190px;
}


.social-item img {
    width: 40px !important;
    height: 40px !important;
}

.social-item a {
    display: block;
    background-color: #fc7b32;
    width: 40px;
    height: 40px;
    padding: 7px;
    border-radius: 30px;
    color: #fff;
}

.social-item {
    display: flex;
    justify-content: space-between;
}

.social-item a svg {
    width: 22px;
}

.message-right .socical {
    margin-top: 10px;
}

@media (max-width: 990px) {

    .message-box .message-block {
        padding: 10px;
        width: 300px;
        border-width: 4px;
    }
    .message-box .message-block p {
        font-size: 1.8rem;
        line-height: 2rem;
    }

    .message-right .message-block {
        right: calc(100% - 200px);
        top: -160px;
        width: 250px;
    }

    .message-left .message-block {
        left: calc(100% - 80px);
        top: -30px;
    }
}

</style>

<style>

</style>